import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-search-input',
  templateUrl: './search-input.component.html',
  styleUrls: ['./search-input.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchInputComponent {
  @Input({ required: true }) public readonly value: string;
  @Input({ required: true }) public readonly label: string;
  @Input({ required: false }) public readonly placeholder: string = 'SEARCH_INPUT_PLACEHOLDER';

  @Output() protected valueChanged: EventEmitter<string> = new EventEmitter<string>();

  protected onValueChanges($event: KeyboardEvent & { target: HTMLInputElement }) {
    this.valueChanged.emit($event.target.value);
  }

  protected onClearInput() {
    this.valueChanged.emit('');
  }
}
